import { jsx as r, jsxs as m, Fragment as A } from "react/jsx-runtime";
import F from "./productInfoTab.module.js";
import { Accordion as J } from "../Accordion/index.js";
import { useTranslation as U } from "../../hooks/useTranslation.js";
import { PREFORMATTED_ATTRIBUTE_NAMES as q, hasExtraPackagingMarkings as w, isPreformattedAttributeName as K } from "../../types/types.js";
import { ReadMore as Q } from "../ReadMore/index.js";
import { transformFishingData as X, transformAdditives as Y, getLocalizedEntry as p, transformActivities as Z } from "../../utils/transformation.js";
import { hasAnyAlcoholData as z, getAlcoholSections as D } from "../../utils/alcohols.js";
import { SectionBlock as d } from "../SectionBlock/SectionBlock.js";
import { ReadMoreWrapper as M } from "../ReadMoreWrapper/ReadMoreWrapper.js";
import { hasAllIngredientNamesInGivenLanguage as ee } from "../../utils/productinfo.js";
const me = ({ productData: o, className: P, language: s }) => {
  const { t: l } = U(), k = () => {
    var c, t, _;
    const { ingredient_list: e, ingredient_list_nonfood: i } = o || {}, n = e == null ? void 0 : e.find(
      (a) => a.language === s || !e.some((h) => h.language === s) && a.language === "fi"
    );
    return ((n == null ? void 0 : n.ingredient_list) || ((c = i[0]) == null ? void 0 : c.ingredient_list_nonfood)) && /* @__PURE__ */ m(d, { title: l("ingredients"), children: [
      (n == null ? void 0 : n.ingredient_list) && /* @__PURE__ */ r(M, { content: n.ingredient_list }),
      ((t = i[0]) == null ? void 0 : t.ingredient_list_nonfood) && /* @__PURE__ */ r(
        M,
        {
          content: (_ = i[0]) == null ? void 0 : _.ingredient_list_nonfood
        }
      )
    ] });
  }, $ = () => {
    const { product_ingredient_details: e } = o || {}, i = e == null ? void 0 : e.some(
      (t) => {
        var _;
        return (_ = t.actions) == null ? void 0 : _.some(
          (a) => {
            var h;
            return (h = a.countries_of_activity) == null ? void 0 : h.some((u) => u.value);
          }
        );
      }
    ), n = e == null ? void 0 : e.some(
      (t) => {
        var _;
        return (_ = t.actions) == null ? void 0 : _.some(
          (a) => {
            var h;
            return (h = a.product_activity_types) == null ? void 0 : h.some((u) => u.value);
          }
        );
      }
    ), c = e == null ? void 0 : e.some(
      (t) => t.ingredient_name
    );
    return !i && !n && !c ? null : /* @__PURE__ */ r(d, { title: l("product_ingredient_details"), children: /* @__PURE__ */ r("ul", { children: e.filter(
      (t) => ee(
        e,
        s
      ) ? t.language === s : t.language === "fi"
    ).map((t, _) => {
      var a, h;
      return /* @__PURE__ */ m("li", { children: [
        `${t == null ? void 0 : t.ingredient_name}${t != null && t.content_percentage ? ` (${parseFloat(t == null ? void 0 : t.content_percentage).toString().replace(".", ",")}%)` : ""}`,
        ((a = t.actions[0]) == null ? void 0 : a.product_activity_types.some(
          (u) => u.language === s || u.language === "fi"
        )) && ((h = t.actions[0]) == null ? void 0 : h.countries_of_activity.some(
          (u) => u.language === s || u.language === "fi"
        )) && /* @__PURE__ */ r("ul", { children: t.actions.map((u, y) => {
          const f = u.product_activity_types.find(
            (b) => b.language === s || !u.product_activity_types.some(
              (g) => g.language === s
            ) && b.language === "fi"
          ), v = u.countries_of_activity.find(
            (b) => b.language === s || !u.countries_of_activity.some(
              (g) => g.language === s
            ) && b.language === "fi"
          );
          return (f == null ? void 0 : f.value) && (v == null ? void 0 : v.value) && /* @__PURE__ */ r("li", { children: `${f.value}: ${v.value}` }, `${_}-${y}`);
        }) }, _)
      ] }, _);
    }) }) });
  }, j = () => {
    var n, c, t, _, a, h, u;
    const { fish_meat_poultries: e } = o || {}, i = (c = (n = e == null ? void 0 : e[0]) == null ? void 0 : n.fish_meat_poultry_types) == null ? void 0 : c.find(
      (y) => {
        var f;
        return y.language === s && y.value || !((f = e == null ? void 0 : e[0]) != null && f.fish_meat_poultry_types.some(
          (v) => v.language === s && v.value
        )) && y.language === "fi" && y.value;
      }
    );
    return (e == null ? void 0 : e[0]) && /* @__PURE__ */ r(d, { title: l("fish_meat_poultries"), children: /* @__PURE__ */ m("div", { children: [
      i == null ? void 0 : i.value,
      " ",
      ((t = e[0]) == null ? void 0 : t.minimum_fish_meat_poultry_content) && parseFloat(
        (_ = e[0]) == null ? void 0 : _.minimum_fish_meat_poultry_content
      ).toString().replace(".", ","),
      (u = (h = (a = e[0]) == null ? void 0 : a.minimum_fish_meat_poultry_content_uoms) == null ? void 0 : h[0]) == null ? void 0 : u.code
    ] }) });
  }, O = () => {
    const { dairy_juice_dry_matter_contents: e } = o || {};
    return e != null && e[0] ? /* @__PURE__ */ m(A, { children: [
      e[0].fat_percentage_in_dry_matter && /* @__PURE__ */ r(d, { title: l("dry_matter"), children: /* @__PURE__ */ m("div", { children: [
        Number(
          o == null ? void 0 : o.dairy_juice_dry_matter_contents[0].fat_percentage_in_dry_matter
        ).toFixed(0),
        "%"
      ] }) }),
      e[0].fat_in_milk_content && /* @__PURE__ */ r(d, { title: l("fat_in_milk"), children: /* @__PURE__ */ m("div", { children: [
        Number(
          o == null ? void 0 : o.dairy_juice_dry_matter_contents[0].fat_in_milk_content
        ).toFixed(0),
        "%"
      ] }) }),
      e[0].juice_content_percentage && /* @__PURE__ */ r(d, { title: l("juice_content"), children: /* @__PURE__ */ m("div", { children: [
        Number(
          o == null ? void 0 : o.dairy_juice_dry_matter_contents[0].juice_content_percentage
        ).toFixed(0),
        "%"
      ] }) })
    ] }) : null;
  }, S = () => {
    const { fishings: e } = o || {};
    return (e == null ? void 0 : e[0]) && /* @__PURE__ */ r(d, { title: l("fishing_info"), children: X(o, l, s).map(
      (i, n) => /* @__PURE__ */ r("div", { children: /* @__PURE__ */ r("ul", { children: i.map((c, t) => /* @__PURE__ */ r("li", { children: Array.isArray(c.value) ? /* @__PURE__ */ m(A, { children: [
        c.key,
        ":",
        /* @__PURE__ */ r("ul", { children: c.value.map((_, a) => /* @__PURE__ */ r("li", { children: _ }, a)) })
      ] }) : `${c.key}: ${c.value}` }, t)) }) }, n)
    ) });
  }, L = () => {
    const { e_numbers: e } = o || {};
    return (e == null ? void 0 : e[0]) && Object.entries(Y(o, s)).map(
      ([i, n], c) => c === 0 && /* @__PURE__ */ r(d, { title: l("additives"), children: n.length > 4 ? /* @__PURE__ */ r(
        Q,
        {
          numberOfLines: 4,
          openText: l("show_everything"),
          closeText: l("hide"),
          fade: !0,
          children: n.map((t, _) => /* @__PURE__ */ r("ul", { children: /* @__PURE__ */ r("li", { children: t.value }) }, _))
        }
      ) : n.map((t, _) => /* @__PURE__ */ r("ul", { children: /* @__PURE__ */ r("li", { children: t.value }) }, _)) }, i)
    );
  }, N = () => {
    const { attributes: e } = o || {}, i = (n) => K(n) ? q[n] : n;
    return o && (z(o) || e.length > 0 && e.some(
      (n) => n.attribute_name && n.attribute_value
    )) && /* @__PURE__ */ m(d, { title: l("attributes"), children: [
      z(o) && D(o, l, s).map(
        (n, c) => n.condition && /* @__PURE__ */ m("div", { children: [
          n.title,
          ": ",
          n.content
        ] }, c)
      ),
      e == null ? void 0 : e.filter((n) => e.some(
        (t) => t.language === s && t.attribute_name && t.attribute_value
      ) ? n.language === s : n.language === "fi").map(
        (n, c) => n.attribute_name && n.attribute_value && /* @__PURE__ */ m("div", { children: [
          i(n.attribute_name),
          ":",
          " ",
          n.attribute_value
        ] }, c)
      )
    ] });
  }, R = () => {
    var n;
    const { names_and_descriptions: e } = o || {}, i = p(
      e,
      s,
      ["nonfood_material_list"]
    );
    return ((n = i == null ? void 0 : i.nonfood_material_list) == null ? void 0 : n.length) && /* @__PURE__ */ r(d, { title: l("materials"), children: /* @__PURE__ */ r("div", { children: i.nonfood_material_list }) });
  }, T = () => {
    const { measurements: e, names_and_descriptions: i } = o || {}, n = p(
      i,
      s,
      ["descriptive_size"]
    );
    return (e == null ? void 0 : e[0]) && (n == null ? void 0 : n.descriptive_size) && /* @__PURE__ */ r(d, { title: l("measurements"), children: /* @__PURE__ */ m("div", { children: [
      l("descriptive_size"),
      ":",
      " ",
      n.descriptive_size.toLowerCase()
    ] }) });
  }, x = () => {
    const { manufacturer: e } = o || {}, i = p(e, s, [
      "contact_name",
      "contact_info"
    ]);
    return i && /* @__PURE__ */ m(d, { title: l("manufacturer"), children: [
      /* @__PURE__ */ r("div", { children: i.contact_name }),
      /* @__PURE__ */ r("div", { children: i.contact_info })
    ] });
  }, C = () => {
    const { produced_for: e } = o || {}, i = p(e, s, [
      "contact_name",
      "contact_info"
    ]);
    return i && /* @__PURE__ */ m(d, { title: l("produced_for"), children: [
      /* @__PURE__ */ r("div", { children: i.contact_name }),
      /* @__PURE__ */ r("div", { children: i.contact_info })
    ] });
  }, E = () => {
    const { consumer_support: e } = o || {}, i = p(e, s, [
      "contact_name",
      "contact_info"
    ]);
    return i && /* @__PURE__ */ m(d, { title: l("consumer_support"), children: [
      /* @__PURE__ */ r("div", { children: i.contact_name }),
      /* @__PURE__ */ r("div", { children: i.contact_info })
    ] });
  }, V = () => {
    const { licensee_registrar: e } = o || {}, i = p(
      e,
      s,
      ["contact_name", "contact_info"]
    );
    return i && /* @__PURE__ */ m(d, { title: l("licensee_registrar"), children: [
      /* @__PURE__ */ r("div", { children: i.contact_name }),
      /* @__PURE__ */ r("div", { children: i.contact_info })
    ] });
  }, H = () => {
    const { countries_of_origin: e } = o || {}, i = e == null ? void 0 : e.find(
      (n) => n.language === s || !e.some((c) => c.language === s) && n.language === "fi"
    );
    return i && /* @__PURE__ */ r(d, { title: l("country_of_origin"), children: /* @__PURE__ */ r("div", { children: i.value }) });
  }, W = () => {
    const { product_activities: e } = o || {};
    return (e == null ? void 0 : e[0]) && /* @__PURE__ */ r(d, { title: l("product_activities"), children: Object.entries(Z(o, s)).map(
      ([i, n]) => /* @__PURE__ */ m("div", { children: [
        i,
        " ",
        n
      ] }, i)
    ) });
  }, B = () => {
    const { responsibilities: e } = o || {}, {
      // carbon_foot_print,
      palm_oil_responsibilities: i,
      soy_responsibilities: n,
      water_foot_print: c,
      cbam_product_code: t,
      animal_welfare: _
    } = (e == null ? void 0 : e[0]) || {};
    return /* @__PURE__ */ m(A, { children: [
      (i == null ? void 0 : i[0]) && /* @__PURE__ */ r(d, { title: l("responsibility_palm_oil"), children: o.responsibilities[0].palm_oil_responsibilities && o.responsibilities.map(
        (a) => a.palm_oil_responsibilities.map((h) => /* @__PURE__ */ r("div", { children: h.value }))
      ) }),
      (n == null ? void 0 : n[0]) && /* @__PURE__ */ r(d, { title: l("responsibility_soy"), children: o.responsibilities[0].palm_oil_responsibilities && o.responsibilities.map(
        (a) => a.soy_responsibilities.map((h) => /* @__PURE__ */ r("div", { children: h.value }))
      ) }),
      c && /* @__PURE__ */ r(d, { title: l("responsibility_water_footprint"), children: /* @__PURE__ */ m("div", { children: [
        c,
        " ",
        l("responsibility_water_footprint_unit")
      ] }) }),
      t && /* @__PURE__ */ r(d, { title: l("responsibility_cbam_product_code"), children: /* @__PURE__ */ r("div", { children: l(
        `responsibility_cbam_product_code_unit_${t}`
      ) }) }),
      _ === "1" && /* @__PURE__ */ r(d, { title: l("responsibility_animal_welfare_title"), children: /* @__PURE__ */ r("div", { children: l("responsibility_animal_welfare_content") }) })
    ] });
  }, I = () => {
    const { warranties: e } = o || {}, i = p(e, s, [
      "warranty_period",
      "warranty_period_uom"
    ]);
    return i && /* @__PURE__ */ r(d, { title: l("warranties"), children: /* @__PURE__ */ m("div", { children: [
      i.warranty_period,
      " ",
      i.warranty_period_uom
    ] }) });
  }, G = () => {
    const { packaging_markings: e } = o || {}, i = (n, c) => {
      const t = n == null ? void 0 : n.find(
        (a) => a.language === c && a.value
      );
      if (t) return t.value;
      const _ = n == null ? void 0 : n.find(
        (a) => a.language === "fi" && a.value
      );
      return (_ == null ? void 0 : _.value) || null;
    };
    return (e == null ? void 0 : e.some(
      (n) => {
        var c;
        return w(n) && ((c = n.trade_item_date_on_packaging_types) == null ? void 0 : c.length) > 0;
      }
    )) && /* @__PURE__ */ r(d, { title: l("packaging_markings"), children: e.map((n, c) => {
      if (w(n)) {
        const t = i(
          n.trade_item_date_on_packaging_types,
          s
        );
        return t ? /* @__PURE__ */ r("div", { children: t }, c) : null;
      }
      return null;
    }) });
  };
  return /* @__PURE__ */ r("div", { className: P, children: /* @__PURE__ */ r(
    J,
    {
      className: F.accordion,
      header: l("product_info"),
      headingLevel: "h2",
      open: !0,
      children: /* @__PURE__ */ m("div", { className: F.accordionContent, children: [
        k(),
        $(),
        j(),
        O(),
        S(),
        L(),
        N(),
        R(),
        T(),
        x(),
        C(),
        E(),
        V(),
        H(),
        W(),
        B(),
        I(),
        G()
      ] })
    }
  ) });
};
export {
  me as ProductInfoTab
};
